module.exports = __webpack_public_path__ + "media/images/phi1-31cf39663e438e77f58a9e4beadae018.jpg";